<script>
	import NumInput from "./NumInput.svelte"
	import { lotWid, lotLen } from "./stores.js"

	const dimIcons = {
		"lot-wid": "width",
		"lot-len": "length"
	}

	let imgSlug = "dimen";
	let iconalt = "Lot dimensions";

	$: {
		iconalt = imgSlug === "dimen" ? "Lot dimensions" : "Lot " + imgSlug;
	}

	function handleFocus(e) {
		let slug = dimIcons[e.target.id];
		imgSlug = slug;
	}

	function handleBlur() {
		imgSlug = "dimen";
	}
</script>

<h3>Lot Dimensions</h3>

<div class="input-group">
	<div class="dim-icon">
		<img src="./img/{imgSlug}-graphic.svg" alt={iconalt}>
	</div>
	<div class="inputs">
		<NumInput label="Width (ft)" bind:val={$lotWid} id="lot-wid" on:focus={handleFocus} on:blur={handleBlur} />
		<NumInput label="Length (ft)" bind:val={$lotLen} id="lot-len" on:focus={handleFocus} on:blur={handleBlur} />
	</div>
</div>
